export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.30-1900.04",
  commitId: "059786a97d4d1426e038e5f3f0241c8f15bd0eea",
  commitTime: "2026-07-30T19:00:04.000Z",
});
